import * as React from "react";

import BaseDialog from "../../modelDialogs/BaseDialog";
import { saveProject } from "../SaveProject";
import { State } from "../../State";
import { runUiCloseAnimation as runGuideUiCloseAnimation } from "../../onBoarding/GuideUtils";
import SavingBecausOfToMuchDevicesNotAllowedDialog from "./SavingBecausOfToMuchDevicesNotAllowedDialog";
import { channelTypeInfo } from "../../models/ChannelType";

export function askToSaveProjectBeforeLeaving(targetUrl?: string) {
  // if (
  //   state.loggedInUser.abo == "no" &&
  //   state.allDevices().filter((dev) => !channelTypeInfo(dev.channelType).isSupply).length > 10
  // ) {
  //   state.dialogManager.openDialog(<SavingBecausOfToMuchDevicesNotAllowedDialog targetUrl={targetUrl} />);
  //   return;
  // }
  if (!state.isDirty) {
    if (targetUrl) {
      state.guideMode.isHidden = true;
      state.guideMode.currentStorylineIndex = 0;
      state.navigate(targetUrl);
      (window as any).secondScreenWindow?.close();
      delete (window as any).secondScreenWindow;
      // window.location.assign(targetUrl);
    }
  } else {
    runGuideUiCloseAnimation();
    var beginnState = state;
    const actualUrl = document.URL.substring(document.URL.lastIndexOf("/"));
    state.dialogManager.openDialog(
      <SaveProjectBeforeLeavingDialog startUrl={actualUrl} targetUrl={targetUrl} beginnState={beginnState} />,
    );
    // state.dialogManager.closeDialog();
  }
}

async function doSave(targetUrl: string | undefined) {
  if (await saveProject()) {
    if (targetUrl) {
      state.dialogManager.closeDialog();
      state.navigate(targetUrl);
    }
  }
}

async function discardProjectAndLeave(targetUrl: string): Promise<void> {
  await state.deleteActiveAutobackups();
  state.clearDirty();
  state.dialogManager.closeDialog();
  state.navigate(targetUrl);
}

export default function SaveProjectBeforeLeavingDialog(props: {
  startUrl?: string;
  targetUrl?: string;
  beginnState?: State;
}) {
  const { startUrl, targetUrl, beginnState } = props;

  // Close (X) Button
  let dialogHeaderCloseButton = (
    <div
      className="dialogHeaderButton"
      onClick={() => {
        state.dialogManager.closeDialog();
        if (startUrl) {
          state.navigate(startUrl);
        }
      }}
    >
      <i
        className={"las la-times"} // no itx
      ></i>
    </div>
  );

  return (
    <BaseDialog
      title={state.translate("saveProjectBeforeLeaving.saveProject?", "Project speichern?")}
      abortCaption={state.translate("saveProjectBeforeLeaving.dontSave", "Nicht speichern")}
      okCaption={state.translate("saveProjectBeforeLeaving.save", "Speichern")}
      onAbort={() => {
        if (targetUrl) {
          void discardProjectAndLeave(targetUrl);
        }
        return false;
      }}
      onOk={() => {
        state.projectMetadata.readOnly = false;
        doSave(targetUrl);
        return false;
      }}
      moreHeaderButtons={dialogHeaderCloseButton}
      hideXButton={true}
    >
      <div style={{ padding: "20px", width: "350px" }}>
        {state.translate(
          "saveProjectBeforeLeaving.saveText",
          "Du bist dabei Dein Projekt zu verlassen. Du solltest es vorher speichern",
        )}
      </div>
    </BaseDialog>
  );
}
